export type Environment = {
	// This isn't really the production environment, just whether Angular should turn off debug checks
	production: boolean;
	deployPath: string;
	apiUrl: string;
	firebase: {
		apiKey: string;
		authDomain: string;
		projectId: string;
		storageBucket: string;
		messagingSenderId: string;
		appId: string;
		measurementId: string;
	};
	mapAPIKey: string;
	/** Microsoft Clarity project for this build. Empty skips Clarity. */
	clarityProjectId?: string;
	isTesting?: boolean; // this is to check whether we are running unit tests
};

// See: https://pumpingco.de/blog/environment-variables-angular-docker/
// See: src/assets/env.js
export const environment: Environment = (window as any).appEnv;
